module.exports = __webpack_public_path__ + "img/List.b31fc53b.svg";